import axiosInstance from './axiosInstance';

export const getAllIncentiveSlips = () =>
    axiosInstance.get("/IncentiveSlip/GetAllSlips");

export const getSlipsByCampaign = (campaignId) =>
    axiosInstance.get(`/IncentiveSlip/GetSlipsByCampaign?campaignId=${campaignId}`);

export const getIncentiveSlipsByAgentId = (agentId) =>
    axiosInstance.get(`/IncentiveSlip/GetSlipsByAgentId?agentId=${agentId}`);

export const getIncentiveSlipsByGroupName = (groupName) =>
    axiosInstance.get(`/IncentiveSlip/GetSlipsByGroupName?groupName=${encodeURIComponent(groupName)}`);

export const generateIncentiveSlips = (campaignId) =>
    axiosInstance.post("/IncentiveSlip/GenerateSlips", { campaignId });

export const approveIncentiveSlip = (incentiveSlipId) =>
    axiosInstance.put("/IncentiveSlip/ApproveSlip", { incentiveSlipId });

export const voidIncentiveSlip = (incentiveSlipId, remarks) =>
    axiosInstance.put("/IncentiveSlip/VoidSlip", { incentiveSlipId, remarks });

export const exportIncentiveMakerCsv = (slipIds) =>
    axiosInstance.get(`/IncentiveSlip/ExportMakerCsv?slipIds=${slipIds.join(',')}`);
